import json from './sprite.js';

export default {
    handle: 'ENG_SPT4-Trees_225002956',
    label: 'en_SPT4-Trees_225002956',
    json,
};
